export default function formatResponseTime(hours) {
  if (hours === 0) return "0 min";
  const roundedHours = Math.floor(hours);
  const minutes = Math.round((hours - roundedHours) * 60);
  return roundedHours === 0
    ? `${minutes} min`
    : `${roundedHours} h ${minutes} min`;
}
